// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const braviary: PokeData = {
  "id": 628,
  "name": "braviary",
  "height": 15,
  "weight": 410,
  "base_experience": 179,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "whirlwind",
    "fury-attack",
    "thrash",
    "leer",
    "peck",
    "sky-attack",
    "slash",
    "scary-face",
    "superpower",
    "crush-claw",
    "aerial-ace",
    "tailwind",
    "air-slash",
    "brave-bird",
    "defog",
    "hone-claws",
    "sky-drop"
  ],
  "moves": [
    "leer",
    "peck",
    "sky-attack",
    "scary-face",
    "superpower",
    "aerial-ace",
    "tailwind",
    "air-slash",
    "brave-bird",
    "headbutt",
    "splash",
    "roost",
    "purification"
  ],
  "evolution_chain": {
    "id": 319,
    "item": null,
    "species": [
      {
        "name": "rufflet",
        "order": 628,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "braviary",
        "order": 629,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 627,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 54,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 110,
    "ability_power": 169
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
